<p>
  지원하지 않는 브라우저입니다.<br /><a
    href="https://www.google.com/intl/ko/chrome"
    target="_blank"
    class="link"
    >크롬 브라우저</a
  >를 사용해주세요!
</p>
<button sui-solid-button (click)="_onBackButtonClick()">뒤로가기</button>
